export default "__VITE_ASSET__CO0BD1WK__"